import { withTransaction } from '@elastic/apm-rum-react'
import { LogService, SocialNetworksAvailables, User, onSocialNetworkConnection, onUserChange } from '@hub/shared'
import EmptySocialNetworksPage from '@pages/social-networks/pages/empty-social-networks/empty-social-networks.page'
import ListSocialNetworksPage from '@pages/social-networks/pages/list-social-networks/list-social-networks.page'
import { SqLoader } from '@squidit/react-css'
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { SubscriptionLike } from 'rxjs'
import './social-networks.page.scoped.scss'

export type ModalStatusTypes = 'loading' | 'initial' | 'instagram-info' | 'profile-category' | 'error' | 'success'

const SocialNetworkPage = (props: any) => {
  const logService = useMemo(() => new LogService(), [])
  logService.init('Social Networks Page')

  const onUserChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [t] = useTranslation('socialNetworksPage')
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState<User | null>(null)
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)
  const [openCategoryForProfileId, setOpenCategoryForProfileId] = useState('')

  const navigate = useNavigate()

  const removeQueryStringFromURL = useCallback(() => {
    navigate(window.location.pathname, { replace: true })
  }, [navigate])

  useEffect(() => {
    onUserChangeSubscription.current = onUserChange.subscribe(async (userChanged: User) => {
      setUser(userChanged)
      setLoading(false)
    })

    return () => {
      onUserChangeSubscription?.current?.unsubscribe()
    }
  }, [])

  useLayoutEffect(() => {
    function updateSize() {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  useEffect(() => {
    setOpenCategoryForProfileId(history.state?.openCategoryForProfileId)
  }, [])

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    if (query.get('action') === 'addProfile') {
      const socialNetwork = (query.get('socialNetwork') as SocialNetworksAvailables) ?? null
      onSocialNetworkConnection?.next({
        connect: true,
        socialNetwork,
      })
      removeQueryStringFromURL()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return (
      <div className="text-center my-5" style={{ width: '100%' }}>
        <SqLoader size="big" />
      </div>
    )
  }

  return (
    <div className="networks-page box p-0" style={{ minHeight: width < 991 ? `calc(${height}px - 51px - 51px)` : 'auto' }}>
      {user?.identities?.length ? (
        <div style={{ height: '100%' }}>
          <h1 className="text-center">{t('title')}</h1>
          <ListSocialNetworksPage user={user} openCategoryForProfileId={openCategoryForProfileId} />
        </div>
      ) : (
        <EmptySocialNetworksPage {...props} user={user} />
      )}
    </div>
  )
}

export default withTransaction('SocialNetworkPage', 'component')(SocialNetworkPage)
